import { XAxisAlignment } from "@/shared/state/visualization/schema/v1";

/**
 * The x-axis label to render on the plot.
 *
 * A user label with any non-whitespace content is returned unchanged.
 * Otherwise an aligned x axis gets a label naming where x = 0 sits, and an
 * unaligned one gets the empty string rather than undefined:
 * PlotManagerWorker.updateAxisConfig ignores an undefined label, so a derived
 * label would stay on the axis after alignment is turned off. The renderer
 * hides a title whose text is empty.
 */
export function effectiveXAxisLabel(
  userLabel: string | undefined,
  alignment: XAxisAlignment | undefined,
): string {
  if (userLabel?.trim()) {
    return userLabel;
  }

  if (alignment === undefined) {
    return "";
  }

  if (alignment.unit === "series") {
    return "Elapsed since each series' first message (s)";
  }

  if (alignment.anchor === "session-start") {
    return "Elapsed since session start (s)";
  }

  if (alignment.anchor === "first-data") {
    return "Elapsed since first data (s)";
  }

  return `Elapsed since event '${alignment.anchor.eventName}' (s)`;
}
